import { render, staticRenderFns } from "./RelettingConfigureAd.vue?vue&type=template&id=2f53fbdd&scoped=true"
import script from "./RelettingConfigureAd.vue?vue&type=script&lang=js"
export * from "./RelettingConfigureAd.vue?vue&type=script&lang=js"
import style0 from "./RelettingConfigureAd.vue?vue&type=style&index=0&id=2f53fbdd&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f53fbdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VListItemSubtitle,VProgressLinear,VRadio,VRadioGroup,VRow})
